module.exports = __webpack_public_path__ + "img/pedro.0f89db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pedro.png
// module id = GOW9
// module chunks = 8